import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_setJobTitleType($coursesData: [CourseData], $jobTitleId: String) {
    Course_setJobTitleType(coursesData: $coursesData, jobTitleId: $jobTitleId) {
      id
    }
  }
`;

const courseSetJobTitleType = async (coursesData, jobTitleId) => {
  return graphql(mutation, { coursesData, jobTitleId })
    .then(data => data.Course_setJobTitleType)
    .catch(e => e);
};

export default courseSetJobTitleType;
